// Imports
var ___HTML_LOADER_IMPORT_0___ = require("./placeholder.svg");
// Module
var code = `<div class="relative"> <div class="{{\$ctrl.styles.browserInfo}}"> <div class="bp-fs-7 bp-c-cloud b ph2 {{\$ctrl.styles.subdomain}}">{{\$ctrl.subdomain}}.{{\$ctrl.BLIP_DOMAIN}}</div> <div class="absolute bp-c-breeze bp-fs-8 {{\$ctrl.styles.name}}"> {{\$ctrl.name}} </div> </div> <div> <img src="${___HTML_LOADER_IMPORT_0___}" alt=""> </div> </div> `;
// Exports
module.exports = code;